import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { COPY } from '../../data/copy';

const LS_KEY = 'professya_exit_shown';

export function ExitIntentPopup() {
  const [visible, setVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(LS_KEY) === '1') return;
    } catch { /* ignore */ }

    let triggered = false;

    function onMouseLeave(e: MouseEvent) {
      if (triggered) return;
      if (e.clientY > 20) return; // Only trigger when cursor exits through the top
      triggered = true;
      setVisible(true);
      try { localStorage.setItem(LS_KEY, '1'); } catch { /* ignore */ }
    }

    document.addEventListener('mouseleave', onMouseLeave);
    return () => document.removeEventListener('mouseleave', onMouseLeave);
  }, []);

  if (!visible) return null;

  const { heading, subheading, offer, ctaPrimary, ctaDismiss, coupon } = COPY.exitIntent;

  function copyCode() {
    navigator.clipboard.writeText(coupon).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => { /* ignore */ });
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={heading}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        background: 'rgba(0,0,0,0.7)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1.5rem',
      }}
      onClick={() => setVisible(false)}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--line-soft)',
          borderRadius: 'var(--radius-lg)',
          padding: 'clamp(2rem, 5vw, 3rem)',
          maxWidth: '480px',
          width: '100%',
          textAlign: 'center',
          position: 'relative',
        }}
      >
        {/* Close */}
        <button
          onClick={() => setVisible(false)}
          aria-label="Fechar"
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--text-muted)',
            fontSize: '1.25rem',
            lineHeight: 1,
            padding: '0.25rem',
          }}
        >
          ✕
        </button>

        <p style={{
          fontSize: '3rem',
          margin: '0 0 1rem',
          lineHeight: 1,
        }} aria-hidden="true">
          ✨
        </p>

        <h2 style={{
          fontFamily: 'var(--font-display)',
          fontSize: 'var(--text-28)',
          fontStyle: 'italic',
          color: 'var(--text-primary)',
          margin: '0 0 0.5rem',
          lineHeight: 1.25,
        }}>
          {heading}
        </h2>

        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: 'var(--text-15)',
          color: 'var(--text-secondary)',
          margin: '0 0 1.5rem',
          lineHeight: 1.6,
        }}>
          {subheading}
        </p>

        {/* Offer badge */}
        <div style={{
          display: 'inline-block',
          background: 'rgba(201,168,76,0.12)',
          border: '2px solid var(--gold)',
          borderRadius: 'var(--radius-lg)',
          padding: '0.75rem 2rem',
          marginBottom: '1.25rem',
        }}>
          <p style={{
            margin: 0,
            fontFamily: 'var(--font-display)',
            fontSize: 'var(--text-28)',
            fontWeight: 400,
            color: '#8a6c1a',
            lineHeight: 1.1,
          }}>
            {offer}
          </p>
        </div>

        {/* Coupon copy */}
        <button
          type="button"
          onClick={copyCode}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            margin: '0 auto 1.5rem',
            padding: '0.5rem 1.25rem',
            background: 'var(--petrol-bg)',
            border: '1px dashed var(--petrol)',
            borderRadius: 'var(--radius-md)',
            cursor: 'pointer',
            fontFamily: 'var(--font-mono)',
            fontSize: 'var(--text-15)',
            fontWeight: 600,
            color: 'var(--petrol)',
            letterSpacing: '0.12em',
            transition: 'background var(--transition-fast)',
          }}
          aria-label={`Copiar código ${coupon}`}
        >
          {coupon}
          <span style={{ fontSize: '0.85em', opacity: 0.7 }}>
            {copied ? '✓' : '⎘'}
          </span>
        </button>

        <Link
          to="/register?promo=exit20"
          className="btn btn-primary btn-block btn-lg"
          onClick={() => setVisible(false)}
        >
          {ctaPrimary}
        </Link>

        <button
          type="button"
          onClick={() => setVisible(false)}
          style={{
            display: 'block',
            margin: '1rem auto 0',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'var(--font-body)',
            fontSize: 'var(--text-13)',
            color: 'var(--text-muted)',
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
          }}
        >
          {ctaDismiss}
        </button>
      </div>
    </div>
  );
}
